// components/RoomStatusColorDisplay.tsx
import React from 'react';

interface RoomStatusColorDisplayProps {
    status: string;
}

const statusColorMap: Record<string, string> = {
    'available': '#28a745',            // green
    'booked': '#007bff',               // blue
    'occupied': '#ffc107',             // yellow
    'maintenance': '#dc3545',          // red
    'closed': '#6c757d',               // gray
    'vacant': '#17a2b8',               // cyan/teal
    'arrival': '#fd7e14',              // orange
};

const RoomStatusColorDisplay: React.FC<RoomStatusColorDisplayProps> = ({ status }) => {
    const color = statusColorMap[status.toLowerCase()] || '#000';

    return (
        <div
            style={{
                width: '100%',
                height: '24px',
                backgroundColor: color,
                borderRadius: '4px',
                border: '1px solid #dee2e6',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.85rem',
                fontWeight: 500,
                overflow: 'hidden', // Menyembunyikan teks yang melebihi batas
                textOverflow: 'ellipsis', // Menambahkan tanda elipsis di akhir teks yang melebihi
                whiteSpace: 'nowrap', // Menjaga teks dalam satu baris
            }}
        >
            {status}
        </div>
    );
};

export default RoomStatusColorDisplay;
